import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import ShowroomPhoto from './ShowroomPhoto';
function Showroompage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <ScrollToTop smooth top="100" color="maroon" />
            <div className='ranaghatsareenew'>
                <div className="album py-1">
                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Showroom Gallery</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <ShowroomPhoto/>

    </div>
  )
}

export default Showroompage